import React from "react";

import destination_1 from "../../public/wheretogo-jeseniky/serak/destination_1.png";
import destination_2 from "../../public/wheretogo-jeseniky/serak/destination_2.png";
import destination_3 from "../../public/wheretogo-jeseniky/serak/destination_3.png";
import destination_4 from "../../public/wheretogo-jeseniky/serak/destination_4.png";
import destination_5 from "../../public/wheretogo-jeseniky/serak/destination_5.png";

import destinationIcon_1 from "../../public/wheretogo-jeseniky/serak/icon_1.png";
import destinationIcon_2 from "../../public/wheretogo-jeseniky/serak/icon_2.png";
import destinationIcon_3 from "../../public/wheretogo-jeseniky/serak/icon_3.png";
import destinationIcon_4 from "../../public/wheretogo-jeseniky/serak/icon_4.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const Serak = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__container">
            <img src={destination_1} alt="" />
            <h1>Šerák</h1>
            <p>
              Šerák je 1351 m vysoká hora v Hrubém Jeseníků, na historické
              hranici Moravy a Slezska. Spolu se sousedním Keprníkem je součástí
              Národní přírodní rezervace Šerák-Keprník a také širšího území CHKO
              Jeseníky.
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__icons--container">
            <div className="destinations__icon">
              <img src={destinationIcon_1} alt="" />
              <p>restaurace</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_2} alt="" />
              <p>1351 m. n. m.</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_3} alt="" />
              <p>lanovka</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_4} alt="" />
              <p>lyžarské sjezdovky</p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`destinations__attractions ${darkMode ? "dark" : "light"}`}
      >
        <div className="container">
          <div className="destinations__attractions--container">
            <div className="destinations__attractions--image">
              <img className="destination_1" src={destination_2} alt="" />
              <img className="destination_2" src={destination_3} alt="" />
              <img className="destination_3" src={destination_4} alt="" />
              <img className="destination_4" src={destination_5} alt="" />
            </div>
            <div className="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  Klimatické podmínky jsou na Šeráku extrémní , průměrná roční
                  teplota je 2,2 °C a je zde sněhova příkryvka 180dni v roce.
                </li>
                <li>
                  Jiřího chata byla původně jako dřevostavba vztyčena již v roce
                  1888 místním horským spolkem MSSGV a pojmenovaná po
                  arcibiskupovi Georgu Koppovi, jenž vlastnil okolní pozemky,
                  Chata byla do současné podoby rozšířena roku 1926.
                </li>
                <li>
                  Na vrchol Šeráku vede sedačková lanová dráha z Ramzové s
                  přestupní stanicí Čerňava. Od horní stanice je na vrchol
                  vzdáleny asi 250 m a nabízí překrásné výhledy především na
                  Jesenicko, Staroměstsko, Králický Sněžník a Rychlebské hory.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Serak;
